import { useEffect, useState } from "react";
import { UserTour } from "./UserTour";
import { supabase } from "@/integrations/supabase/client";

interface TourProviderProps {
  children: React.ReactNode;
  forceTour?: boolean;
}

export const TourProvider = ({ children, forceTour = false }: TourProviderProps) => {
  const [showTour, setShowTour] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkTourStatus = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        
        if (!user) {
          setLoading(false);
          return;
        }

        // If forced (admin testing), show immediately
        if (forceTour) {
          setShowTour(true);
          setLoading(false);
          return;
        }

        // Check if tour has been completed
        const { data: preferences } = await supabase
          .from('user_preferences')
          .select('tour_completed')
          .eq('user_id', user.id)
          .single();

        // Show tour if not completed
        if (preferences && !preferences.tour_completed) {
          // Small delay to ensure UI is ready
          setTimeout(() => {
            setShowTour(true);
          }, 500);
        }
      } catch (error) {
        console.error('Error checking tour status:', error);
      } finally {
        setLoading(false);
      }
    };

    checkTourStatus();
  }, [forceTour]);

  if (loading) {
    return <>{children}</>;
  }

  return (
    <>
      {children}
      {showTour && (
        <UserTour
          onComplete={() => setShowTour(false)}
          onSkip={() => setShowTour(false)}
        />
      )}
    </>
  );
};
